export default __webpack_public_path__ + "static/media/pf.2a8553a3.png";